import axios, { CancelToken } from 'axios';

/**
 * 可取消请求门闩：发新请求前 cancel 上一次，并用 seq 防止过期响应写状态或误关 loading。
 */
export class FetchCancelGate {
    /** 取消上一请求的函数，不参与 MobX 追踪 */
    private cancelFn: (() => void) | null = null;

    /** 请求代数，每次 begin 递增 */
    private seq = 0;

    /**
     * 取消上一请求并开始新一代。
     * @returns cancelToken 供 axios 透传；seq 供回调判断是否仍为最新一代
     */
    begin(): { cancelToken: CancelToken; seq: number } {
        this.cancelFn?.();
        const seq = ++this.seq;
        const cancelToken = new axios.CancelToken((cancel) => {
            this.cancelFn = cancel;
        });
        return { cancelToken, seq };
    }

    /** 仅 cancel 当前进行中的请求，不递增 seq（用于取消子路径而不发起新请求） */
    abort(): void {
        this.cancelFn?.();
        this.cancelFn = null;
    }

    /** 判断 seq 是否仍为最新一代 */
    isLatest(seq: number): boolean {
        return seq === this.seq;
    }

    /**
     * 仅最新一代关闭 loading，避免被取消的请求提前把 loading 置 false。
     * @param seq - begin 返回的代数
     * @param setLoading - 写入 loading 的回调
     */
    endLoading(seq: number, setLoading: (value: boolean) => void): void {
        if (this.isLatest(seq)) {
            setLoading(false);
        }
    }
}
